import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=72cd253a&scoped=true"
import script from "./pending.vue?vue&type=script&lang=js"
export * from "./pending.vue?vue&type=script&lang=js"
import style0 from "./pending.vue?vue&type=style&index=0&id=72cd253a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd253a",
  null
  
)

export default component.exports